/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdWebFeaturesAuthAuthenticateWithExternalIdAdditionalOptions, FxIdWebFeaturesAuthAuthenticateWithExternalIdAdditionalOptionsFromJSONTyped, FxIdWebFeaturesAuthAuthenticateWithExternalIdAdditionalOptionsToJSON, } from './FxIdWebFeaturesAuthAuthenticateWithExternalIdAdditionalOptions';
export function FxIdWebFeaturesAuthAuthenticateWithExternalIdRequestAdditionalOptionsFromJSON(json) {
    return FxIdWebFeaturesAuthAuthenticateWithExternalIdRequestAdditionalOptionsFromJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthAuthenticateWithExternalIdRequestAdditionalOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdWebFeaturesAuthAuthenticateWithExternalIdAdditionalOptions(json)) {
        return FxIdWebFeaturesAuthAuthenticateWithExternalIdAdditionalOptionsFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdWebFeaturesAuthAuthenticateWithExternalIdRequestAdditionalOptionsToJSON(json) {
    return FxIdWebFeaturesAuthAuthenticateWithExternalIdRequestAdditionalOptionsToJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthAuthenticateWithExternalIdRequestAdditionalOptionsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdWebFeaturesAuthAuthenticateWithExternalIdAdditionalOptions(value)) {
        return FxIdWebFeaturesAuthAuthenticateWithExternalIdAdditionalOptionsToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdWebFeaturesAuthAuthenticateWithExternalIdRequestAdditionalOptions.js.map